<mat-form-field [style.width]="width" class="virtual-list1" [ngClass]="class" floatLabel="never">
  <input matInput tabindex="-1" #ctrlInput
    (focus)="setIsSearchingValue()" (click)="getRealSelectedValue() ; " (keyup)="updateFilterList(ctrlInput.value)" [formControl]="accontListCtrl" placeholder="{{(submittedNumber === 0) ? placeholder : 'Selected Account(s) - ' + submittedNumber}}">
  </mat-form-field>
  <input type="text" autofocus="autofocus" style="display:none" />
  @if (isSearching) {
    <div class="autocomplete" [style.width]="(width) ? width + 'vw' : autoCompleteWidth?.width +'px'"
      [style.top.px]="autoCompleteTop" [style.max-height.px]="autoCompleteHeight">
      <cdk-virtual-scroll-viewport [itemSize]="30.4" class="drop-down" [style.height.px]="dropDownHeight">
        <ul>
          @if (!noData) {
            <li>
          <mat-checkbox matRippleDisabled="true" (change)="selectedAll($event.checked)" [checked]="isAllSelected
            || selectedAccounts.length == allAccounts.length">All</mat-checkbox>
            </li>
          }
          <li *cdkVirtualFor="let list of filteredList;">
            <mat-checkbox (change)="selectField($event, list)" [disabled]="list.isDisabled" [checked]="list?.isSelected">
              {{list?.linkedAccountName}}
              {{list?.accountCode ? '(' + list?.accountCode + ')' : ''}}
            </mat-checkbox>
          </li>
          @if (noData) {
            <li class="no-record"><span>No records..</span></li>
          }
        </ul>
      </cdk-virtual-scroll-viewport>
      <footer>
        <button mat-button color="warn" type="button" class="clear" [disabled]="selectedAccounts.length === 0"
        (click)="selectedAccounts.length > 0 && clearAll(); ctrlInput.value = null">Clear All</button>
        <button mat-button color="primary" type="button" class="apply" [disabled]="selectedAccounts.length === 0" (click)="applyFilter();ctrlInput.value = null">Apply</button>
      </footer>
    </div>
  }
